<template>
    <div>
        <h3
            :class="{'padding-top': padding}"
            v-html="changesLabel"
        />

        <div v-html="changesHtml" />
    </div>
</template>
<script>
export default {
    name: 'Changes',
    props: {
        padding: {
            type: Boolean,
            default() {
                return true;
            }
        }
    },
    computed: {
        changesLabel() {
            return this.$store.getters['policy/changesLabel'];
        },
        changesHtml() {
            return this.$store.getters['policy/changesAsList'];
        }
    }
};
</script>
<style lang="scss" scoped>
@import 'node_modules/foundation-sites/scss/util/util';

h3 {
    font-style: bold;
}

.padding-top {
    padding-top: rem-calc(20px);
}
</style>
